export default __webpack_public_path__ + "static/media/art.fb47fdb4.png";